import React, { useState, useEffect, useRef } from 'react';
import { Table, Thead, Tbody, Tr, Th, Td, chakra, Box, Text, Button, Icon, Flex, useToast, Center, Input, Select, InputGroup, InputRightElement, VStack, Textarea, Alert } from '@chakra-ui/react'

import { Drawer, DrawerBody, DrawerFooter, DrawerHeader, DrawerOverlay, DrawerCloseButton, DrawerContent, } from '@chakra-ui/react'

import ChacraAlert from '../GlobalComponents/ChakraAlert';
import { ErrorToast, WarnToast, CheckToast } from '../GlobalComponents/CustomToast';
import BaseModal from '../GlobalComponents/BaseModal';

export default function DeviceRename(props) {

  const [NameText, setNameText] = useState('');
  const [change, setChange] = useState(false);

  const InputRef = useRef(null);

  const toast = useToast();
  const toastIdRef = React.useRef();

  useEffect(() => {
  }, []);

  function confirmHandler() {

    if (InputRef.current && InputRef.current.value) {

      props.onConfirm(InputRef.current.value)
    }
  }

  return (
    <BaseModal isOpen={props.isOpen} onClose={() => props.onClose()} closeOnEsc
      style={{ maxWidth: '450px', minWidth: '450px', maxHeight: '300px', minHeight: '150px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 15 }}>

      <Text fontSize='25px' color='#222' fontWeight='bold' marginBottom={3}>Gerätename umbenennen:</Text>

      {props.device ? (
        <>
          <Flex width='100%' justifyContent='space-between' marginRight={4} marginLeft={4}>
            <Text maxWidth='40%'>{props.device.DeviceID}</Text>
            <Text maxWidth='40%'>{props.device.IP_Addr}</Text>
          </Flex>

          <Input placeholder='Gerätename' size='md' width='100%' defaultValue={props.device.Device_Name} marginTop={2} ref={InputRef} />
        </>
      ) : null}

      <Flex mt={3} Flex={1} width={'100%'} height={'50%'} justifyContent='space-evenly' alignItems='center'>

        <Button variant='outline' colorScheme='blue' mr={3} onClick={() => props.onClose()} >Abbrechen</Button>
        <Button colorScheme='blue' onClick={() => confirmHandler()}>Speichern</Button>

      </Flex>

    </BaseModal>
  )
}